/*
*创建还款支付单   http://192.168.0.26:8765/doc.html#/haolv-consumer/t-us-company-credit-controller/createRefundPaymentUsingPOST_1
*/
const __request = require(`./__request/__request_contentType_json`)
const request = (data) => {
    let pParameter = {
        method: 'post',
        urlSuffix: '/consumer/credit/createRefundPayment',
        data: data
    }
    return __request(pParameter)
}
export default request